var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 363,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-343 -147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.581 449.5 537.734 192.375C532.062 182.166 517.316 182.166 511.644 192.375L363.419 449.5C357.747 459.709 364.931 472.188 376.653 472.188L524.5 472.188 672.347 472.188C684.069 472.188 691.253 459.709 685.581 449.5ZM513.156 252.875 535.844 252.875 535.844 385.219 513.156 385.219 513.156 252.875ZM524.5 438.156C513.912 438.156 505.594 429.838 505.594 419.25 505.594 408.662 513.912 400.344 524.5 400.344 535.088 400.344 543.406 408.662 543.406 419.25 543.406 429.838 535.088 438.156 524.5 438.156Z",
    fill: "#0DCAF0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIr);
export default __webpack_public_path__ + "static/media/IR.8e6121b2760c0f9417d391e7cc54d14c.svg";
export { ForwardRef as ReactComponent };